import { render, staticRenderFns } from "./AgentTransactions.vue?vue&type=template&id=2e2225be&scoped=true"
import script from "./AgentTransactions.vue?vue&type=script&lang=js"
export * from "./AgentTransactions.vue?vue&type=script&lang=js"
import style0 from "./AgentTransactions.vue?vue&type=style&index=0&id=2e2225be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2225be",
  null
  
)

export default component.exports